import Composite from '../components/composite';
import Quantity from '../components/quantity';
import GalleryExtension from '../components/gallery-extension';
import Toggle3d from '../components/toggle-3d';

export default {
  init() {
    GalleryExtension.init()
    $('.js-comf-composite').each(function () {
      let composite = new Composite($(this));
      composite.init()
    })

    let $quantity = new Quantity('.js-quantity')
    $quantity.init()

    
    Toggle3d.init()
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js